// extracted by mini-css-extract-plugin
module.exports = {"ChatPageContainer":"ChatPageContainer_ChatPageContainer__DmxbW"};